import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesSchemesAssociateDefaultRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-schemes-associate-default',
	path: '/secure/admin/AssociateIssueTypeSchemesWithDefault!default.jspa',
};
